import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "lDdj6f",
    defaultMessage: "Create model",
    description: "page header",
  },
  seoOptionsDescription: {
    id: "r7uSVR",
    defaultMessage: "Add search engine title and description to make this model easier to find",
    description: "model seo options description",
  },
  hiddenLabel: {
    id: "5MtM5w",
    defaultMessage: "Hidden",
    description: "model label",
  },
  hiddenSecondLabel: {
    id: "7X0w8O",
    defaultMessage: "will be visible from {date}",
    description: "model",
  },
  visibleLabel: {
    id: "GLsIie",
    defaultMessage: "Visible",
    description: "model label",
  },
  setAvailabilityDate: {
    id: "nK68Sg",
    defaultMessage: "Set availability date",
    description: "model availability date label",
  },
  viewPage: {
    id: 'EHPihZ',
    defaultMessage: "View Page",
    description: "view page button",
  },
});
